<template>
    <div class="movies">
        <div class="return-button">
            <a class="return" href="./"><i class="fas fa-arrow-left"></i> &nbsp; Return</a>
        </div>
        <div class="movie">
          <a class="image" target="_blank">
            <img v-bind:src="data.Poster">
          </a>
          <div class="about">
            <span class="title">
                <a class="title" target="_blank" >
                {{ data.Title }}
                </a>
            </span>
            <div class="plot">
                {{ data.Plot }}
            </div>
            <div class="rating">
                <p>
                    <span>IMDb</span> {{ data.Ratings[0].Value }}
                </p>
            </div>
            <div class="index">
              <a target="_blank" v-bind:href="`https://www.google.com/search?client=firefox-b-d&q=<index+of>+${data.Title}`">
                  Watch {{ data.Type }}
              </a>
          </div>
          </div>            
        </div>
    </div>
</template>

<script>
export default {
    name: 'movie',
    props: ['data']
}
</script>

<style scoped>

.movie {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5%;
  margin-bottom: 5%;
}

.movie img {
  width: 200px;
  margin-right: 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  transition: 0.5s all;
}


.movie .about {
  width: 250px;
  margin-left: 10px;
}

.plot {
    font-size: 13px;
    margin-top: 10px;
    margin-bottom: 10px;
    opacity: 0.8;
}

.movie a {
  color: #1C2833;
  text-decoration: none;
  font-weight: 600;
  font-size: 24px;
}

.movies {
  min-height: calc(100vh - 33px - 37px)
}

.rating span {
    font-weight: 600;
    color: #1C2833;
}

.rating {
    margin-bottom: 20px;
}

.index a:link, .index a:visited {
    background-color: #212f3c;
    border-radius: 5px;
    padding: 7.5px 15px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    transition: 0.5s all;
}

@media only screen and (max-width: 580px) {
  .movies {
    margin-top: 12.5%;
  }

  .movie {
    margin-left: 5%;
  }

  .movie img {
    width: 180px;
  }

  .about {
    width: 120px;
  }

  .movie .title {
    font-size: 20px;
  }

  .index a:link, .index a:visited{
      padding: 5px 10px;
  }
}

.index a:hover {
    opacity: 0.9;
}

.return-button {
  text-align: center;
  margin-top: 20px;
}

.return:link, .return:visited {
    color: #1C2833;
    text-decoration: none;
}

</style>